import './media-restriction.scss';

class MediaRestriction {
    constructor (element) {
        this.$mediaRestriction = element;
        this.$mediaRestrictionRenewCTA = this.$mediaRestriction.querySelector('[data-media-restriction="renew"]');
        this.isActive = true; // active state of the media restriction - is set to false if consent is given
        this.consentCategory = this.$mediaRestriction.dataset.mediaRestrictionCategory;
        this.cmpCategories = {};
    }

    initialize () {
        const waitForConsent = setInterval(() => {
            this.cmpCategories = this.getCMPCategories();

            if (this.cmpCategories !== {}) {
                clearInterval(waitForConsent);
                this.checkConsentByCategory();

                this.$mediaRestrictionRenewCTA.onclick = () => {
                    this.setConsentByCategory();
                };
            }
        }, 300);

        setTimeout(() => {
            clearInterval(waitForConsent);
        }, 2000); // clear interval after 2 seconds - to prevent infinite loop
    }


    checkConsentByCategory () {
        if (this.cmpCategories[this.consentCategory] !== undefined && this.cmpCategories[this.consentCategory] === true) {
            this.isActive = false;
        }

        this.$mediaRestriction.dataset.mediaRestrictionActive = this.isActive;

        window.dispatchEvent(new CustomEvent('check.cookie_consent', {
            view: window,
            bubbles: true,
            cancelable: false,
            detail: {
                consentCategory: this.consentCategory,
                consentStatus: !this.isActive
            }
        }));
    }

    setConsentByCategory () {
        __cmp('setVendorConsent', [this.consentCategory, 1]); // set a new consent category
        window.location.reload();
    }

    getCMPCategories () {
        let cmpData = null;

        __cmp('getCMPData', null, function(data) { // get cmp data
            cmpData = data;
        });

        if (cmpData === null) {
            return {};
        } else {
            return cmpData.vendorConsents; // get consent categories from cmp data
        }
    }
}

export { MediaRestriction };

window.addEventListener('content.loaded', (e) => {
    const $$mediaRestriction = e.detail.$context.querySelectorAll('[data-media-restriction="root"]:not([data-init="true"])');

    $$mediaRestriction.forEach($mediaRestriction => {
        const mediaRestriction = new MediaRestriction($mediaRestriction);
        mediaRestriction.initialize();
        $mediaRestriction.setAttribute('data-init', 'true');
    });
});
